import banner_oem_01 from "../assets/image/oem/01.webp";
import banner_oem_02 from "../assets/image/oem/02.webp";
import banner_oem_03 from "../assets/image/oem/03.webp";
import banner_oem_04 from "../assets/image/oem/04.webp";
import banner_oem_05 from "../assets/image/oem/05.webp";
import banner_home_01 from "../assets/image/home/01.webp";
import banner_home_02 from "../assets/image/home/02.webp";
import banner_home_03 from "../assets/image/home/03.webp";
import banner_about_01 from "../assets/image/about/01.webp";
import banner_about_02 from "../assets/image/about/02.webp";
import banner_about_03 from "../assets/image/about/03.webp";
import banner_about_04 from "../assets/image/about/04.webp";


export const oemBanners = [banner_oem_01, banner_oem_02, banner_oem_03, banner_oem_04, banner_oem_05]

export const homeBanners = [
    {
        'img': banner_home_01,
        'title': 'home_banner_title_1',
        'subtitle': 'home_banner_subtitle_1',
    },
    {
        'img': banner_home_02,
        'title': 'home_banner_title_2',
        'subtitle': 'home_banner_subtitle_2',
    },
    {
        'img': banner_home_03,
        'title': 'home_banner_title_3',
        'subtitle': 'home_banner_subtitle_3',
    },
]

export const aboutBanners = [banner_about_01, banner_about_02, banner_about_03, banner_about_04]